<template>
  <div class="listing-header">
    <router-link
      v-if="to && !isEmpty"
      :to="to"
      class="listing-header__link listing-header__link--link"
    >
      <h2 class="listing-header__title section-title">{{ title }}</h2>
      <span class="listing-header__btn">{{ viewAllText || 'View all' }}</span>
    </router-link>
    <div v-else class="listing-header__link">
      <h2 class="listing-header__title section-title">{{ title }}</h2>
    </div>
    <div v-if="$slots.default" class="listing-header__actions">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  to?: any
  title: string
  viewAllText?: string
  isEmpty?: boolean
}>()
</script>

<style lang="scss" scoped>
.listing-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  @media only screen and (max-width: $w-tablet-s) {
    margin-bottom: 14px;
  }

  &__link {
    display: inline-flex;
    justify-content: start;
    align-items: center;
    color: $c-black-2;
    .listing-header__btn {
      z-index: 2;
    }
  }
  &__link--link {
    @include hover {
      color: $c-black-3;
      .listing-header__btn {
        background-color: $c-yellow;
        border-color: $c-yellow;
        color: $c-black-15;
      }
    }
  }
  &__title {
    &.section-title {
      // Override .section-title
      margin: 0;
    }
  }
  &__btn {
    display: inline-block;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    color: $c-black-2;
    padding: 8px 19px 6px;
    margin-left: 16px;
    border: 1px solid $c-yellow;
    border-radius: 53px;
    background-color: $c-yellow-2;
    transition: all 0.2s ease-in-out;
    @media only screen and (max-width: $w-tablet-s) {
      padding: 9px 15px 7px;
    }
    &:after {
      font-family: 'iconfont';
      display: inline-block;
      content: '\f107';
      padding-left: 5px;
    }
  }
  &__actions {
    margin-left: auto;
  }
}

.listing-header-btn-box {
  text-align: center;
  margin-top: 18px;
  @media only screen and (min-width: $w-tablet-b) {
    display: none;
  }
}

.night-mode .listing-header {
  &__link {
    color: $c-white;
    @include hover {
      color: $c-white;
      .listing-header__btn {
        background-color: $c-yellow;
        border-color: $c-yellow;
        color: $c-black-2;
      }
    }
  }
  &__btn {
    color: $c-dark-4;
    border: 1px solid $c-yellow;
    background-color: $c-yellow-9;
  }
}
</style>
